var map = {
	"./147.png": "ac29",
	"./Baselogin.jpg": "0675",
	"./En_cofig.jpg": "acc8",
	"./En_cofig_1.jpg": "1555",
	"./Facebook.png": "9a63",
	"./Flag_RD.png": "5f4c",
	"./Flag_RD1.png": "cfa5",
	"./Flag_RD2.png": "2a15",
	"./Google_Mail.png": "42d2",
	"./LogPrincipal.jpg": "5dbd",
	"./TransporNet.jpg": "031f",
	"./calendar-alt.svg": "16d2",
	"./calendar.svg": "1a34",
	"./entrenamiento.png": "66ec",
	"./faltas-iconos/accidente.png": "c84e",
	"./faltas-iconos/accidente32.png": "deb6",
	"./faltas-iconos/conduccion.png": "bace",
	"./faltas-iconos/conduccion32.png": "f1ea",
	"./faltas-iconos/otroempleado.png": "500c",
	"./faltas-iconos/otroempleado32.png": "af0c",
	"./faltas-iconos/otros.png": "ab3e",
	"./faltas-iconos/otros32.png": "20f69",
	"./faltas-iconos/pasajero.png": "dfa6",
	"./faltas-iconos/pasajero32.png": "7c86",
	"./faltas-iconos/photothumb.db": "8d2f",
	"./faltas-iconos/uniforme.png": "6f4a",
	"./faltas-iconos/uniforme32.png": "3630",
	"./file-alt.svg": "68f6",
	"./file-invoice-dollar.svg": "8d32",
	"./file-invoice.svg": "d59c",
	"./iconos_micromarket/01-128.png": "4800",
	"./iconos_micromarket/03_office_employee_avatar_man_chart_graph_presentation-256.png": "6750",
	"./iconos_micromarket/11-Checkout-256.png": "415f",
	"./iconos_micromarket/12-128.png": "cbd7",
	"./iconos_micromarket/21-128.png": "2aad",
	"./iconos_micromarket/48_office_employee_man_growth_performance_board_chart_statics-256.png": "e6ed",
	"./iconos_micromarket/93-256.png": "4fd0",
	"./iconos_micromarket/945_business_employee_woman_resume_recruitment_success_selected-256.png": "af2d",
	"./iconos_micromarket/Accounting-256.png": "2f627",
	"./iconos_micromarket/Bank-128.png": "4689",
	"./iconos_micromarket/Big_Taxes-256.png": "fd98",
	"./iconos_micromarket/Ecommerce_Set-28-512.png": "b804",
	"./iconos_micromarket/LogoMicroMarket-2d-completo.gif": "4903",
	"./iconos_micromarket/Policeman.png": "5fcb",
	"./iconos_micromarket/Prescription-512.png": "0b62",
	"./iconos_micromarket/Utilitario.png": "4a13",
	"./iconos_micromarket/aars.png": "f9fa",
	"./iconos_micromarket/acc.png": "9678",
	"./iconos_micromarket/avatar.png": "2c7a",
	"./iconos_micromarket/avatar04.png": "4c84",
	"./iconos_micromarket/avatar2.png": "8cc1",
	"./iconos_micromarket/avatar3.png": "4df1",
	"./iconos_micromarket/avatar5.png": "5658",
	"./iconos_micromarket/bank.png": "a711",
	"./iconos_micromarket/boxed-bg.jpg": "6ba9",
	"./iconos_micromarket/boxed-bg.png": "5ddc",
	"./iconos_micromarket/busT - copia.png": "dc54",
	"./iconos_micromarket/busT.png": "4423",
	"./iconos_micromarket/busT0.png": "744d",
	"./iconos_micromarket/cajachica.png": "116e",
	"./iconos_micromarket/cashbox.png": "894a",
	"./iconos_micromarket/cheque-128.png": "c80a",
	"./iconos_micromarket/combustible.png": "c377",
	"./iconos_micromarket/combustible2.png": "bd2c",
	"./iconos_micromarket/cont.png": "d2b1",
	"./iconos_micromarket/contrucion/En_cofig.jpg": "2112",
	"./iconos_micromarket/contrucion/photothumb.db": "67f5",
	"./iconos_micromarket/cotizar.png": "bcde",
	"./iconos_micromarket/credit/american-express.png": "a0b8",
	"./iconos_micromarket/credit/cirrus.png": "9263d",
	"./iconos_micromarket/credit/mastercard.png": "b76e",
	"./iconos_micromarket/credit/mestro.png": "5ba6",
	"./iconos_micromarket/credit/paypal.png": "53cb",
	"./iconos_micromarket/credit/paypal2.png": "1c89",
	"./iconos_micromarket/credit/photothumb.db": "c4ec",
	"./iconos_micromarket/credit/visa.png": "05eb",
	"./iconos_micromarket/custom-reports.png": "5f1a",
	"./iconos_micromarket/cxca.png": "31e6",
	"./iconos_micromarket/cxpa.png": "1db7",
	"./iconos_micromarket/default-50x50.gif": "2eca",
	"./iconos_micromarket/entrenamiento.png": "9c42",
	"./iconos_micromarket/entrenamientoB.png": "af13",
	"./iconos_micromarket/finance_-68-128.png": "7fff",
	"./iconos_micromarket/fork2.png": "a1e9",
	"./iconos_micromarket/forklift__distribution_warehouse_equipment_loader-128.png": "8e44",
	"./iconos_micromarket/gas.png": "a170",
	"./iconos_micromarket/gnome-keyring-manager.png": "d6af",
	"./iconos_micromarket/gobCon.png": "e804",
	"./iconos_micromarket/group_businessman-256.png": "0655",
	"./iconos_micromarket/icoFacturacioFi.png": "6194",
	"./iconos_micromarket/icoRefielectric.png": "e7a2",
	"./iconos_micromarket/icon.jpg": "709c",
	"./iconos_micromarket/icon2.png": "c680",
	"./iconos_micromarket/icon_page/FAVICON.ICO": "0547",
	"./iconos_micromarket/icon_page/photothumb.db": "8a50",
	"./iconos_micromarket/icon_page/user-login-icon-14.png": "3120",
	"./iconos_micromarket/icons.png": "7687",
	"./iconos_micromarket/imagenMM.gif": "f1e2",
	"./iconos_micromarket/img-p.jpg": "9c24",
	"./iconos_micromarket/img-p.png": "481a",
	"./iconos_micromarket/img-p2.jpg": "3506",
	"./iconos_micromarket/img_reportes/EstadosCuentasGAS.PNG": "a935",
	"./iconos_micromarket/img_reportes/Reporte_cxc.PNG": "35a4",
	"./iconos_micromarket/img_reportes/analisisComparativoGastos.PNG": "85ba",
	"./iconos_micromarket/img_reportes/balance_cero.PNG": "a21d",
	"./iconos_micromarket/img_reportes/comisionesvenderoesporcobroCXP.PNG": "55e3",
	"./iconos_micromarket/img_reportes/cumpleanosPancientes.PNG": "06ec",
	"./iconos_micromarket/img_reportes/depositoFAcCXC.PNG": "2e9c",
	"./iconos_micromarket/img_reportes/diariocomprasCXP.PNG": "f983",
	"./iconos_micromarket/img_reportes/estadocuentaCXC.PNG": "c071",
	"./iconos_micromarket/img_reportes/estadocuentaCXP2.PNG": "874a",
	"./iconos_micromarket/img_reportes/listadoVentasporVendedor.PNG": "767c",
	"./iconos_micromarket/img_reportes/movimiento_documento.PNG": "66df",
	"./iconos_micromarket/img_reportes/mvpodc.PNG": "fd52",
	"./iconos_micromarket/img_reportes/photothumb.db": "50b9",
	"./iconos_micromarket/img_reportes/relacionnotasdecreditoVentas.PNG": "9f90",
	"./iconos_micromarket/img_reportes/relaciovalecajasVentas.PNG": "1d85",
	"./iconos_micromarket/img_reportes/reporteCXC.PNG": "5cab",
	"./iconos_micromarket/img_reportes/reporte_ventas_productos.PNG": "7748",
	"./iconos_micromarket/img_reportes/ventasvendedorVentas.PNG": "ff30",
	"./iconos_micromarket/inv.png": "b61a",
	"./iconos_micromarket/lg-mk.png": "0689",
	"./iconos_micromarket/loader01.gif": "4d04",
	"./iconos_micromarket/lock_thumb.jpg": "f327",
	"./iconos_micromarket/log-deca-012.png": "745e",
	"./iconos_micromarket/logo/LogoMicroMarket-2d-completofondo.jpg": "10c4",
	"./iconos_micromarket/logo/farmacon.png": "fbb3",
	"./iconos_micromarket/logo/log-deca-012.png": "d46c",
	"./iconos_micromarket/logo/logo.PNG": "514b",
	"./iconos_micromarket/logo/logoFinalMK.gif": "4bca",
	"./iconos_micromarket/logo/logo_1.PNG": "2ee9",
	"./iconos_micromarket/logo/photothumb.db": "553a",
	"./iconos_micromarket/logo/transpornet.jpeg": "648e",
	"./iconos_micromarket/logo/transpornet.png": "993c",
	"./iconos_micromarket/medicina.png": "2bf5",
	"./iconos_micromarket/medicina2.png": "aa5a",
	"./iconos_micromarket/medico.png": "db36",
	"./iconos_micromarket/missing_product.png": "c560",
	"./iconos_micromarket/modf.png": "7bcb",
	"./iconos_micromarket/nom.png": "bea8",
	"./iconos_micromarket/palet03.png": "1b77",
	"./iconos_micromarket/payment-512.png": "0cca",
	"./iconos_micromarket/payment_service-128.png": "6bf6",
	"./iconos_micromarket/photo1.png": "3bb5",
	"./iconos_micromarket/photo2.png": "ef8a",
	"./iconos_micromarket/photo3.jpg": "3a59",
	"./iconos_micromarket/photo4.jpg": "cc1f",
	"./iconos_micromarket/photothumb.db": "e0a3",
	"./iconos_micromarket/porcientoDescuento.jpg": "2359",
	"./iconos_micromarket/porcientoretnecion.png": "0b64",
	"./iconos_micromarket/preferences-desktop-cryptography.png": "7404",
	"./iconos_micromarket/pro5.png": "9cc6",
	"./iconos_micromarket/produccion100.png": "13cb",
	"./iconos_micromarket/punto.png": "4cbb",
	"./iconos_micromarket/punto2.png": "c0f8",
	"./iconos_micromarket/pva.png": "1c16",
	"./iconos_micromarket/rep.png": "d27e",
	"./iconos_micromarket/sal.png": "00d3",
	"./iconos_micromarket/seg.png": "bff8",
	"./iconos_micromarket/self1.png": "d8a9",
	"./iconos_micromarket/sulidores2.png": "f4e0",
	"./iconos_micromarket/suplidores1.png": "6276",
	"./iconos_micromarket/suplidores3.png": "f797",
	"./iconos_micromarket/user1-128x128.jpg": "3a25",
	"./iconos_micromarket/user2-160x160.jpg": "1f61",
	"./iconos_micromarket/user3-128x128.jpg": "1b89",
	"./iconos_micromarket/user4-128x128.jpg": "9295",
	"./iconos_micromarket/user5-128x128.jpg": "855d",
	"./iconos_micromarket/user6-128x128.jpg": "74fe",
	"./iconos_micromarket/user7-128x128.jpg": "b181",
	"./iconos_micromarket/user8-128x128.jpg": "5811",
	"./iconos_micromarket/user_person_manager_employee_leader_businessman_business_man-256.png": "3416",
	"./iconos_micromarket/vector_210-252_41-256.png": "61a6",
	"./icons/alteza.png": "3e8b",
	"./icons/barrica.png": "7939",
	"./icons/camion.png": "81ff",
	"./icons/cash-register.svg": "8681",
	"./icons/conductor.png": "4256",
	"./icons/factura.png": "464a",
	"./icons/ganadero.png": "7695",
	"./icons/leche.png": "b86c",
	"./icons/menu.svg": "d17f",
	"./icons/nomina.png": "d13b",
	"./icons/photothumb.db": "9751",
	"./icons/precio.png": "9996",
	"./icons/prestamo.png": "ae67",
	"./icons/recepcion.png": "3f4a",
	"./icons/registro.png": "967e",
	"./icons/retencion.png": "c360",
	"./icons/ruta.png": "4d16",
	"./icons/save.png": "c9ee",
	"./icons/ticket.png": "2475",
	"./icons_logo/Decasystem.png": "271f",
	"./icons_logo/TransporNet-Antes.png": "f330",
	"./icons_logo/TransporNet.jpg": "dcff",
	"./icons_logo/TransporNet.png": "fe2b",
	"./icons_logo/farmacon.png": "b37f",
	"./icons_logo/farmaconAntes.png": "5726",
	"./icons_logo/farmaconNuevoOriginal.png": "cbf9",
	"./icons_logo/gobCon.png": "0027",
	"./icons_logo/gobConWeb.png": "897f",
	"./icons_logo/logoAntes/TransporNet.jpg": "bbab",
	"./icons_logo/logoAntes/farmacon.png": "857f",
	"./icons_logo/logoAntes/logoFinalMK.gif": "6c38",
	"./icons_logo/logoAntes/logoFinalMKLite.png": "9ca2",
	"./icons_logo/logoFinalMK-ORIGINAL.png": "e9a7",
	"./icons_logo/logoFinalMK.gif": "cb80",
	"./icons_logo/logoFinalMK.png": "c1c8",
	"./icons_logo/logoFinalMKAntes.png": "1c3c",
	"./icons_logo/logoFinalMKLite.png": "468b",
	"./icons_logo/photothumb.db": "97e1",
	"./icons_pv/cambiodivisa-icon.png": "9f88",
	"./icons_pv/cierrecaja-icon.png": "9550",
	"./icons_pv/cliente-icon.png": "2b38",
	"./icons_pv/conducefactura-icon.png": "f675",
	"./icons_pv/cotizar-icon.png": "aaba",
	"./icons_pv/descfactura.png": "6ca3",
	"./icons_pv/devoluciones-icon.png": "b380",
	"./icons_pv/extras/guardar.png": "4d49",
	"./icons_pv/extras/historial.png": "30a2",
	"./icons_pv/extras/limpiarPantalla.png": "a254",
	"./icons_pv/extras/photothumb.db": "d532",
	"./icons_pv/extras/seleccionar48.png": "a012",
	"./icons_pv/formapago/BonoGas1-35.png": "9fe0",
	"./icons_pv/formapago/BonoGas35.png": "c0fd",
	"./icons_pv/formapago/asignacion35.png": "9fae",
	"./icons_pv/formapago/cheques35.png": "77d0",
	"./icons_pv/formapago/conduce.png": "d7b3",
	"./icons_pv/formapago/conduce35activo.png": "a036",
	"./icons_pv/formapago/conduce35activo2.png": "58b0",
	"./icons_pv/formapago/credito35.png": "8b38",
	"./icons_pv/formapago/cupones35.png": "479a",
	"./icons_pv/formapago/donacion1-35.png": "7d49",
	"./icons_pv/formapago/donacion2-35.png": "e4db",
	"./icons_pv/formapago/efectivo35.png": "2e53",
	"./icons_pv/formapago/notacredito35.png": "1779",
	"./icons_pv/formapago/photothumb.db": "39ab",
	"./icons_pv/formapago/puntos2-35.png": "7f06",
	"./icons_pv/formapago/puntos35.png": "6a41",
	"./icons_pv/formapago/tarjeta35.png": "6be8",
	"./icons_pv/formapago/transferencia35.png": "e229",
	"./icons_pv/formapago/traspaso35.png": "7261",
	"./icons_pv/img/CIERRE Z-20.png": "1b4c",
	"./icons_pv/img/Crear cotizacion-36-36.png": "d31a",
	"./icons_pv/img/Crear cotizacion-36.png": "f5ae",
	"./icons_pv/img/Factura domicilio4-27.png": "54df",
	"./icons_pv/img/L ventas-22.png": "8300",
	"./icons_pv/img/Lventas4-08.png": "f1bd",
	"./icons_pv/img/agregar-23.png": "c202",
	"./icons_pv/img/agregar-43.png": "40b8",
	"./icons_pv/img/agregarcarrito.png": "7be5",
	"./icons_pv/img/agregarcarrito48.png": "f191",
	"./icons_pv/img/alertaBlanca64.png": "9109",
	"./icons_pv/img/apartado.png": "bbd3",
	"./icons_pv/img/apartado2.png": "0659",
	"./icons_pv/img/apartado4-36.png": "7345",
	"./icons_pv/img/aplicar-32.png": "7c64",
	"./icons_pv/img/aplicarDescuento-32.png": "57d6",
	"./icons_pv/img/aplicarDescuento4-16.png": "574a",
	"./icons_pv/img/aplicarRetencion-34.png": "4422",
	"./icons_pv/img/aplicarRetencion4-18.png": "5909",
	"./icons_pv/img/aplicar_recargo-33.png": "ea16",
	"./icons_pv/img/aplicar_recargo4-17.png": "3744",
	"./icons_pv/img/apratado4-13.png": "b9e8",
	"./icons_pv/img/asignarMensajero-40.png": "b140",
	"./icons_pv/img/asignarMensajero4-21.png": "3e26",
	"./icons_pv/img/atras.png": "32c9",
	"./icons_pv/img/atras48.png": "b20a",
	"./icons_pv/img/bien-42.png": "801b",
	"./icons_pv/img/buscar-28.png": "a36e",
	"./icons_pv/img/buscar24.png": "b09f",
	"./icons_pv/img/buscar32.png": "ca6d",
	"./icons_pv/img/buscar4-34.png": "cf78",
	"./icons_pv/img/buscarBlanco16.png": "158d",
	"./icons_pv/img/buscarNegro16.png": "4950",
	"./icons_pv/img/calculadora.png": "ce0a",
	"./icons_pv/img/cambioDivisas64.png": "bb03",
	"./icons_pv/img/cancelarDocumento.png": "8514",
	"./icons_pv/img/cancelarDocumento48.png": "6855",
	"./icons_pv/img/cancelarUltimoDocumento-24.png": "293d",
	"./icons_pv/img/cancelarUltimoDocumento4-10.png": "91915",
	"./icons_pv/img/cheques.png": "44b8",
	"./icons_pv/img/ciercaj48.png": "1b28",
	"./icons_pv/img/ciercaj64.png": "dfa4",
	"./icons_pv/img/cierre caja.png": "badd",
	"./icons_pv/img/cierre caja2.png": "26e9",
	"./icons_pv/img/cierre.png": "9a1f",
	"./icons_pv/img/cierre4-06.png": "9692",
	"./icons_pv/img/cierre48.png": "cbe6",
	"./icons_pv/img/cierreFechas.png": "f8a0",
	"./icons_pv/img/cierreFechas48.png": "afbb",
	"./icons_pv/img/cierreRangoFecha-18-18.png": "ae21",
	"./icons_pv/img/cierreRangoFecha-18.png": "29e7",
	"./icons_pv/img/cierreRangoFecha4-04.png": "2940",
	"./icons_pv/img/cierreRangoNumero-19.png": "d7ee",
	"./icons_pv/img/cierreRangoNumero4-05.png": "3121",
	"./icons_pv/img/cierreZ.png": "d7261",
	"./icons_pv/img/cierreZ4-06.png": "5402",
	"./icons_pv/img/cierreZ48.png": "9921",
	"./icons_pv/img/cliente.png": "b991",
	"./icons_pv/img/cliente2.png": "eb23",
	"./icons_pv/img/cliente4.png": "bd6c",
	"./icons_pv/img/closeAzul32.png": "b5d9",
	"./icons_pv/img/closeRed32.png": "dafd",
	"./icons_pv/img/close_blanco16.png": "0892",
	"./icons_pv/img/cobertura-48.png": "ae0e",
	"./icons_pv/img/cobertura4-28.png": "e86f",
	"./icons_pv/img/cobertura4-35.png": "9672",
	"./icons_pv/img/comentario-34.png": "9d48",
	"./icons_pv/img/comentario-51.png": "da01",
	"./icons_pv/img/comentario34-34.png": "cef1",
	"./icons_pv/img/comentarios.png": "8bd1",
	"./icons_pv/img/cordon.png": "4cb1",
	"./icons_pv/img/cotizacion.png": "fa57",
	"./icons_pv/img/cotizacion48.png": "cc79",
	"./icons_pv/img/crear cotizacion4-19.png": "afb6",
	"./icons_pv/img/cupon.png": "d434",
	"./icons_pv/img/cxc.png": "5873",
	"./icons_pv/img/delivery.png": "1924",
	"./icons_pv/img/des factura.png": "e231",
	"./icons_pv/img/des factura2.png": "0823",
	"./icons_pv/img/descuento.png": "ff4a",
	"./icons_pv/img/descuento_fac-08.png": "6094",
	"./icons_pv/img/detalle-24.png": "4d65",
	"./icons_pv/img/detalle-44.png": "9030",
	"./icons_pv/img/devol4.png": "1467",
	"./icons_pv/img/devolucion.png": "b461",
	"./icons_pv/img/devoluciones48.png": "c468",
	"./icons_pv/img/dinero.png": "e720",
	"./icons_pv/img/doctor64.png": "bf65",
	"./icons_pv/img/domicilio.png": "af30",
	"./icons_pv/img/domicilio2.png": "a321",
	"./icons_pv/img/domicilio4-14.png": "ec33",
	"./icons_pv/img/editar-31.png": "3a03",
	"./icons_pv/img/editar-39.png": "3f7a",
	"./icons_pv/img/editar.png": "2eff",
	"./icons_pv/img/editar48.png": "d4c2",
	"./icons_pv/img/eliminar-52.png": "7974",
	"./icons_pv/img/eliminar.png": "947f",
	"./icons_pv/img/eliminar4-37.png": "5be8",
	"./icons_pv/img/emptyPocket.png": "776b",
	"./icons_pv/img/eraser 16.png": "1132",
	"./icons_pv/img/eraser24.png": "4289",
	"./icons_pv/img/eraser32.png": "ee49",
	"./icons_pv/img/eye.png": "1b31",
	"./icons_pv/img/eye24.png": "f10a",
	"./icons_pv/img/eye48.png": "504a",
	"./icons_pv/img/fact domicilio-14.png": "084d",
	"./icons_pv/img/factura domicilio-29.png": "074e",
	"./icons_pv/img/factura domicilio-47.png": "aff1",
	"./icons_pv/img/factura-27.png": "8d2b",
	"./icons_pv/img/factura.png": "5972",
	"./icons_pv/img/factura4-12.png": "ebd7",
	"./icons_pv/img/facturas48.png": "8319",
	"./icons_pv/img/guardar.png": "1b2b",
	"./icons_pv/img/historial-11.png": "81f1",
	"./icons_pv/img/historial-29.png": "68eb",
	"./icons_pv/img/historial48.png": "6841",
	"./icons_pv/img/history.png": "c535",
	"./icons_pv/img/history32.png": "f6f3",
	"./icons_pv/img/i fiscal4-07.png": "8d96",
	"./icons_pv/img/icon_image2.png": "b950",
	"./icons_pv/img/impresion fiscal.png": "c1ff",
	"./icons_pv/img/impresion fiscal2.png": "6006",
	"./icons_pv/img/impresoraFiscal.png": "89bb",
	"./icons_pv/img/imprimir-30.png": "27c1",
	"./icons_pv/img/imprimir.png": "2be5",
	"./icons_pv/img/imprimir16.png": "765c",
	"./icons_pv/img/imprimir24.png": "df68",
	"./icons_pv/img/imprimir4-03.png": "1a53",
	"./icons_pv/img/imprimir48.png": "704d",
	"./icons_pv/img/imprimirUltimoDocumento-23.png": "0827",
	"./icons_pv/img/imprimirUltimoDocumento4-09.png": "9b36",
	"./icons_pv/img/info.png": "bcbf",
	"./icons_pv/img/limpiarPantalla.png": "f8a3",
	"./icons_pv/img/mensajero.png": "9865",
	"./icons_pv/img/mensajero4-15.png": "6e7c",
	"./icons_pv/img/mensajero5-15.png": "7a28",
	"./icons_pv/img/minimize.png": "a451",
	"./icons_pv/img/modificar-45.png": "041e",
	"./icons_pv/img/modificar4-25.png": "8b9b",
	"./icons_pv/img/moneda-30.png": "5a54",
	"./icons_pv/img/moneda.png": "b55e",
	"./icons_pv/img/moneda2.png": "a23f",
	"./icons_pv/img/moneda50-50.png": "5b5c",
	"./icons_pv/img/monedas.png": "d587",
	"./icons_pv/img/ndc.png": "e77e",
	"./icons_pv/img/noImage.png": "434a",
	"./icons_pv/img/nuevoArchivo.png": "ea3b",
	"./icons_pv/img/otros ing4-03.png": "4fe5",
	"./icons_pv/img/otros ingresos.png": "984c",
	"./icons_pv/img/otros ingresos2.png": "db91",
	"./icons_pv/img/otrosIngresos.png": "6f01",
	"./icons_pv/img/otrosIngresos48.png": "6c11",
	"./icons_pv/img/photothumb.db": "889b",
	"./icons_pv/img/productos.png": "1a75",
	"./icons_pv/img/puntos.png": "13a7",
	"./icons_pv/img/quitar24.png": "d348",
	"./icons_pv/img/quitar32.png": "9742",
	"./icons_pv/img/rec factura.png": "5cd8",
	"./icons_pv/img/rec factura2.png": "99a4",
	"./icons_pv/img/recargo fac-09.png": "a53a",
	"./icons_pv/img/recargo.png": "c124",
	"./icons_pv/img/receta-16.png": "6bae",
	"./icons_pv/img/receta.png": "a310",
	"./icons_pv/img/recibirMensajero-41.png": "b565",
	"./icons_pv/img/recibirMensajero.png": "696e5",
	"./icons_pv/img/recibirMensajero4-22.png": "14b1",
	"./icons_pv/img/recibo.png": "0aa6",
	"./icons_pv/img/reciboIngreso48.png": "9328",
	"./icons_pv/img/regresar.png": "bf20",
	"./icons_pv/img/regresar4-01.png": "18bc",
	"./icons_pv/img/reimp4.png": "bf84",
	"./icons_pv/img/reimpresion.png": "becc",
	"./icons_pv/img/reimpresion2.png": "961f",
	"./icons_pv/img/reporte x-21.png": "0a99",
	"./icons_pv/img/reporteX4-07.png": "1e69",
	"./icons_pv/img/reportes.png": "0889",
	"./icons_pv/img/reportes48.png": "ee95",
	"./icons_pv/img/rest fac-04.png": "1bd4",
	"./icons_pv/img/restaurar factura.png": "c88a",
	"./icons_pv/img/restaurar factura2.png": "83a7",
	"./icons_pv/img/restaurar.png": "d9ac",
	"./icons_pv/img/ret factura.png": "592c",
	"./icons_pv/img/ret factura2.png": "cf89",
	"./icons_pv/img/retencion fac-10.png": "6759",
	"./icons_pv/img/retenciones.png": "8d98",
	"./icons_pv/img/salvar.png": "0d21",
	"./icons_pv/img/salvar2.png": "4e02",
	"./icons_pv/img/salvar4-02.png": "2167",
	"./icons_pv/img/seguro.png": "9265",
	"./icons_pv/img/seguro32.png": "b12b",
	"./icons_pv/img/seguro48.png": "1861",
	"./icons_pv/img/seleccionar-38.png": "3c8f",
	"./icons_pv/img/seleccionar.png": "9e3d",
	"./icons_pv/img/seleccionar4-32.png": "cb53",
	"./icons_pv/img/seleccionar48.png": "9867",
	"./icons_pv/img/siguiente.png": "9fe4",
	"./icons_pv/img/transferencia.png": "769b",
	"./icons_pv/img/vale caja.png": "f1f1",
	"./icons_pv/img/vale caja2.png": "9fab",
	"./icons_pv/img/vale caja4-05.png": "c397",
	"./icons_pv/img/valeCaja.png": "5fce",
	"./icons_pv/img/valeCaja48.png": "0788",
	"./icons_pv/img/vendedores.png": "c456",
	"./icons_pv/img/ventas.png": "96bf",
	"./icons_pv/img/ventas48.png": "1367",
	"./icons_pv/img/ver Detalle-49.png": "6241",
	"./icons_pv/img/ver cotizacion-37.png": "92b3",
	"./icons_pv/img/ver cotizacion4-20.png": "3b19",
	"./icons_pv/img/verArchivo.png": "43ba",
	"./icons_pv/img/verDetalle-33.png": "bda0",
	"./icons_pv/img/verDetalle-49.png": "d174",
	"./icons_pv/img/verDetalle4-33.png": "136c",
	"./icons_pv/img/viejo/cliente.png": "d155",
	"./icons_pv/img/viejo/cotizacion.png": "7242",
	"./icons_pv/img/viejo/cotizacion2.png": "4e52",
	"./icons_pv/img/viejo/cotizacion4-12.png": "53e0",
	"./icons_pv/img/viejo/devolucion.png": "3240",
	"./icons_pv/img/viejo/devolucion2.png": "77b9",
	"./icons_pv/img/viejo/devolucion4-13.png": "8288",
	"./icons_pv/img/viejo/imprimir-30.png": "8e01",
	"./icons_pv/img/viejo/imprimir4-03.png": "78a7",
	"./icons_pv/img/viejo/mensajero.png": "4091",
	"./icons_pv/img/viejo/mensajero2.png": "a791",
	"./icons_pv/img/viejo/photothumb.db": "77e4",
	"./icons_pv/img/viejo/producto.png": "613c",
	"./icons_pv/img/viejo/producto2.png": "23fd",
	"./icons_pv/img/viejo/producto4.png": "19c0",
	"./icons_pv/img/viejo/receta.png": "1421",
	"./icons_pv/img/viejo/receta2.png": "1a71",
	"./icons_pv/img/viejo/recibo.png": "29f8",
	"./icons_pv/img/viejo/recibo2.png": "9cd5",
	"./icons_pv/img/viejo/recibo4-02.png": "de68",
	"./icons_pv/img/viejo/seguro-11.png": "1a85",
	"./icons_pv/img/viejo/seguro.png": "907a",
	"./icons_pv/img/viejo/seguro2.png": "589b",
	"./icons_pv/img/viejo/siguiente-17.png": "d6e5",
	"./icons_pv/img/viejo/siguiente.png": "4f45",
	"./icons_pv/img/viejo/siguiente2.png": "479a1",
	"./icons_pv/img/viejo/vendedor-32.png": "9fdc",
	"./icons_pv/img/viejo/vendedor2-14.png": "818d",
	"./icons_pv/impfiscal/cancelarDocumento64.png": "b511",
	"./icons_pv/impfiscal/cierre64.png": "5a25",
	"./icons_pv/impfiscal/cierreZ64.png": "380a",
	"./icons_pv/impfiscal/imprimir64.png": "f535",
	"./icons_pv/impfiscal/photothumb.db": "ab38",
	"./icons_pv/impfiscal/reportes64.png": "576e",
	"./icons_pv/impfiscal/ventas64.png": "69a2",
	"./icons_pv/impfiscales-icon.png": "526a",
	"./icons_pv/internamientos.png": "7bf1",
	"./icons_pv/mensajero-icon.png": "6a96",
	"./icons_pv/menu/ClientePreferencial.png": "6913",
	"./icons_pv/menu/ClientePreferencial64.png": "0fa7",
	"./icons_pv/menu/Conduce.png": "d7dc",
	"./icons_pv/menu/Conduce2-64.png": "c374",
	"./icons_pv/menu/Conduce2.png": "54ed",
	"./icons_pv/menu/Conduce64.png": "fd37",
	"./icons_pv/menu/DatosVuelo1-64.png": "e8f0",
	"./icons_pv/menu/DatosVuelo64.png": "aeae",
	"./icons_pv/menu/Originals/cancelado.png": "5af7",
	"./icons_pv/menu/Reimpresion64.png": "bf83",
	"./icons_pv/menu/apartarProducto64.png": "dc68",
	"./icons_pv/menu/cambioDivisas64.png": "a807",
	"./icons_pv/menu/cambioMensajero64.png": "68e9",
	"./icons_pv/menu/cancelado.png": "0b0a",
	"./icons_pv/menu/cierrecaja64.png": "ac7d",
	"./icons_pv/menu/cliente64.png": "676d",
	"./icons_pv/menu/comentarios64.png": "d708",
	"./icons_pv/menu/comprobantes.png": "ad56",
	"./icons_pv/menu/comprobantes64.png": "594b",
	"./icons_pv/menu/contrato.png": "74cc",
	"./icons_pv/menu/contrato64.png": "9907",
	"./icons_pv/menu/cotizacion64.png": "7b6c",
	"./icons_pv/menu/delivery64.png": "8517",
	"./icons_pv/menu/descuento64.png": "acd7",
	"./icons_pv/menu/devolucion64.png": "12d0",
	"./icons_pv/menu/factura64.png": "e5ac",
	"./icons_pv/menu/facturasRutas64.png": "3d56",
	"./icons_pv/menu/impresoraFiscal64.png": "5071",
	"./icons_pv/menu/medico64.png": "127a",
	"./icons_pv/menu/mensajero64.png": "023d",
	"./icons_pv/menu/monedas64.png": "565a",
	"./icons_pv/menu/otrosIngresos64.png": "a02d",
	"./icons_pv/menu/pagare64.png": "521c",
	"./icons_pv/menu/pedido64.png": "9e74",
	"./icons_pv/menu/pendienteEntrega64.png": "e48c",
	"./icons_pv/menu/photothumb.db": "748a",
	"./icons_pv/menu/productos64.png": "96c4",
	"./icons_pv/menu/recargo64.png": "5ee0",
	"./icons_pv/menu/receta64.png": "da0c",
	"./icons_pv/menu/recibirMensajero64.png": "c1a0",
	"./icons_pv/menu/recibo64.png": "4d6f",
	"./icons_pv/menu/restaurar64.png": "c74b",
	"./icons_pv/menu/retenciones64.png": "65f5",
	"./icons_pv/menu/seguro64.png": "57a4",
	"./icons_pv/menu/valeCaja64.png": "05d3",
	"./icons_pv/menu/vendedores64.png": "b7ba",
	"./icons_pv/menu/vigilancia64.png": "45f8",
	"./icons_pv/photothumb.db": "6e89",
	"./icons_pv/producto-icon.png": "7bb7",
	"./icons_pv/receta-icon.png": "ae49",
	"./icons_pv/recibos-icon.png": "e014",
	"./icons_pv/reimpresion-icon.png": "7d8b",
	"./icons_pv/restaurarfactura-icon.png": "1556",
	"./icons_pv/retencionfactura-icon.png": "f63a",
	"./icons_pv/seguro-icon.png": "e50c",
	"./icons_pv/valecaja-icon.png": "c0df",
	"./img/Nofoto.png": "f2d3",
	"./img/advertencia.jpg": "49ca",
	"./img/caritatriste.png": "6415",
	"./img/imagenMM.gif": "fd70",
	"./img/loading-icon.gif": "0526",
	"./img/loading.gif": "f8b2",
	"./img/logo.png": "4ffd",
	"./img/logo_banreservas.png": "cd90",
	"./img/logoleche.jpg": "e0ce",
	"./img/photothumb.db": "80d6",
	"./img/stop.png": "bf2e",
	"./img/user.png": "0f71",
	"./log.png": "c3b4",
	"./logo copy.png": "d90a",
	"./logo copy.svg": "a600",
	"./logo.png": "cf05",
	"./logo.svg": "9b19",
	"./money-check.svg": "9ae7",
	"./photothumb.db": "2bd1",
	"./plus.svg": "8a37",
	"./pva.png": "ec6c",
	"./receipt.svg": "eae8",
	"./scroll.svg": "d4cd",
	"./warehouse.png": "d726"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";